import { fromPairs, keyBy } from 'lodash';
import { difference, union } from 'ramda';
import { Empty, Loaded, Loading, Refreshing } from 'stores/core';
const EMPTY = {
    byId: {},
    ids: Empty()
};
const load = ()=>({ byId, ids })=>({
            byId,
            ids: ids[0] === 'refreshing' || ids[0] === 'loading' ? ids : ids[0] === 'loaded' ? Refreshing(ids) : Loading()
        });
const putAll = (companies)=>()=>{
        const ids = companies.map(({ companyId })=>companyId);
        const lookup = keyBy(companies, 'companyId');
        return {
            byId: fromPairs(ids.map((id)=>[
                    id,
                    lookup[id]
                ])),
            ids: Loaded(ids)
        };
    };
const loaded = ({ ids })=>ids[0] === 'loaded';
const toList = ({ ids: [, companyIds = []], byId })=>companyIds.map((x)=>byId[x]).filter(Boolean);
const ofId = ([, companyId])=>({ byId })=>byId[companyId];
const added = (company)=>(store)=>{
        const { byId, ids } = store;
        if (ids[0] !== 'loaded') {
            return store;
        }
        return {
            byId: {
                ...byId,
                [company.companyId]: company
            },
            ids: Loaded(union(ids[1], [
                company.companyId
            ]))
        };
    };
const updated = (company)=>(store)=>added(company)(store);
const removed = ([, companyId])=>(store)=>{
        const { byId: { [companyId]: _removed, ...byId }, ids } = store;
        if (ids[0] !== 'loaded') {
            return store;
        }
        return {
            byId,
            ids: Loaded(difference(ids[1], [
                companyId
            ]))
        };
    };
export const CompaniesStore = {
    empty: ()=>EMPTY,
    load,
    putAll,
    loaded,
    toList,
    ofId,
    added,
    updated,
    removed
};
